import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function Address() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    location: "",
    city: "",
    pincode: "",
    state: "",
    phone: "",
    type: "",
    deliveryDays: "7",
  });

  const [user, setuser] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [addresses, setAddresses] = useState([]);

  const userId = localStorage.getItem("userId");
  const navigate = useNavigate();

  const handleAddressClick = () => {
    navigate("/Getaddress");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const storedUserString = localStorage.getItem("userId");

    if (!storedUserString) {
      console.error("User not found in localStorage");
      return;
    }

    const userId = storedUserString;

    const formDataToSend = {
      name: formData.name,
      email: formData.email,
      location: formData.location,
      city: formData.city,
      pincode: formData.pincode,
      phone: formData.phone,
      state: formData.state,
      type: formData.type,
      deliveryDays: formData.deliveryDays,
    };

    try {
      const response = await axios.post(
        `https://www.bharatcod.com/user/add-address-web/${userId}`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setIsModalOpen(true);
      setTimeout(() => {
        navigate("/Getaddress");
      }, 2000);
    } catch (error) {
      console.error("❌ Error adding address:", error);
    }
  };

  useEffect(() => {
    const fetchAddresses = async () => {
      try {
        if (!userId) {
          console.error("User ID not found");
          return;
        }

        const response = await axios.get(
          `https://www.bharatcod.com/user/get-user-address/${userId}`
        );

        setAddresses(response.data);

        if (response.data && response.data.length > 0) {
          const firstAddressId = response.data[0]._id;

          if (firstAddressId) {
            localStorage.setItem("addressId", firstAddressId);
          }
        } else {
          console.warn("⚠️ No addresses found to save addressId");
        }
      } catch (error) {
        console.error("Error fetching addresses:", error);
      }
    };

    fetchAddresses();
  }, [userId]);

  const handleDelete = async () => {
    try {
      const addressId = localStorage.getItem("addressId");
      if (!addressId) {
        alert("Address ID not found!");
        return;
      }

      const response = await axios.delete(
        `https://www.bharatcod.com/user/delete-address-web/${addressId}`
      );

      if (response.status === 200) {
        alert("Address deleted successfully!");
        window.location.reload();
      }
    } catch (error) {
      console.error("Error deleting address:", error);
      alert("Failed to delete address.");
    }
  };

  return (
    <div>
      <div className="max-w-4xl mx-auto mt-32 mb-8">
        <h1 className="text-4xl font-semibold text-gray-800 text-center mb-8">
          Select Your Address
        </h1>

        {addresses.length === 0 ? (
          <p className="text-lg text-gray-600 text-center">
            You have no saved addresses.
          </p>
        ) : (
          <div className="space-y-6">
            {addresses.map((address) => (
              <div
                key={address._id}
                onClick={handleAddressClick}
                className="cursor-pointer bg-white p-6 rounded-xl border border-gray-300 hover:shadow-xl transition duration-300 ease-in-out"
              >
                <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center">
                  <div>
                    <h3 className="text-xl font-semibold text-gray-800">
                      {address.name}
                    </h3>
                    <p className="text-gray-500 text-sm capitalize">
                      {address.type} Address
                    </p>
                  </div>
                </div>

                <div className="mt-4 space-y-2 text-sm text-gray-600">
                  <p>
                    {address.location}, {address.city}
                  </p>
                  <p>
                    {address.state} - {address.pincode}
                  </p>
                  <p>📞 {address.phone}</p>
                  <p>📧 {address.email.replace("mailto:", "")}</p>
                  <p>🚚 Estimated delivery: {address.deliveryDays} days</p>
                </div>

                <div className="mt-4 flex justify-end">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDelete(address._id);
                    }}
                    className="bg-red-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-red-700 focus:outline-none"
                  >
                    Delete
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <div className="max-w-4xl mx-auto p-6 bg-gray-100  rounded-lg">
        <h1 className="text-3xl font-semibold text-gray-800 mb-6">
          Address Form
        </h1>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label
              htmlFor="name"
              className="block text-sm font-medium text-gray-700"
            >
              Name
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter your name"
              className="mt-2 p-3 w-full border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div>
            <label
              htmlFor="email"
              className="block text-sm font-medium text-gray-700"
            >
              Email
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter your email"
              className="mt-2 p-3 w-full border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div>
            <label
              htmlFor="location"
              className="block text-sm font-medium text-gray-700"
            >
              Location
            </label>
            <input
              type="text"
              id="location"
              name="location"
              value={formData.location}
              onChange={handleChange}
              placeholder="Enter your location"
              className="mt-2 p-3 w-full border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div>
            <label
              htmlFor="city"
              className="block text-sm font-medium text-gray-700"
            >
              City
            </label>
            <input
              type="text"
              id="city"
              name="city"
              value={formData.city}
              onChange={handleChange}
              placeholder="Enter your city"
              className="mt-2 p-3 w-full border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div>
            <label
              htmlFor="pincode"
              className="block text-sm font-medium text-gray-700"
            >
              Pincode
            </label>
            <input
              type="text"
              id="pincode"
              name="pincode"
              value={formData.pincode}
              onChange={handleChange}
              placeholder="Enter your pincode"
              className="mt-2 p-3 w-full border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div>
            <label
              htmlFor="state"
              className="block text-sm font-medium text-gray-700"
            >
              State
            </label>
            <input
              type="text"
              id="state"
              name="state"
              value={formData.state}
              onChange={handleChange}
              placeholder="Enter your state"
              className="mt-2 p-3 w-full border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div>
            <label
              htmlFor="phone"
              className="block text-sm font-medium text-gray-700"
            >
              Phone
            </label>
            <input
              type="number"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="Enter your phone number"
              className="mt-2 p-3 w-full border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div>
            <label
              htmlFor="type"
              className="block text-sm font-medium text-gray-700"
            >
              Type
            </label>
            <input
              type="text"
              id="type"
              name="type"
              value={formData.type}
              onChange={handleChange}
              placeholder="Enter type (e.g., Residential, Commercial)"
              className="mt-2 p-3 w-full border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div className="flex justify-between">
            <button
              type="submit"
              className="mt-4 py-2 px-6 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none"
            >
              Submit
            </button>
          </div>
        </form>
        {isModalOpen && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white rounded-lg p-6 shadow-lg max-w-sm w-full text-center">
              <h2 className="text-xl font-semibold text-green-600">
                🎉 Address Added!
              </h2>
              <p className="mt-2 text-gray-600">
                Your address has been added successfully.
              </p>
              <button
                onClick={() => setIsModalOpen(false)}
                className="mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Address;
